import Api from './api'

class ProjectService {
    getProjects({ permKey } = {}) {
        return Api.sendRequest({
            method: 'get',
            path: 'user/project/index',
            params: permKey ? { perm_key: permKey } : {}
        })
    }

    // Hands off a resource the current user just connected to the target project's owner.
    // See ProjectController::actionClaimResource — distinct from assignBot (grouping only).
    claimResource({ resource_key, project_code }) {
        return Api.sendRequest({
            method: 'post',
            path: 'user/project/claim-resource',
            body: { resource_key, project_code }
        })
    }

    createProject(data) {
        return Api.sendRequest({
            method: 'post',
            path: 'user/project/create',
            body: data
        })
    }

    updateProject(data) {
        return Api.sendRequest({
            method: 'post',
            path: 'user/project/update',
            body: data  // { code, name }
        })
    }

    deleteProject(code) {
        return Api.sendRequest({
            method: 'post',
            path: 'user/project/delete',
            body: { code }
        })
    }

    assignBot(bot_key, project_code) {
        return Api.sendRequest({
            method: 'post',
            path: 'user/project/assign-bot',
            body: { bot_key, project_code }
        })
    }

    getResources(code) {
        return Api.sendRequest({
            method: 'get',
            path: 'user/project/resources',
            params: { code }
        })
    }
}

export default new ProjectService()
